export default "__VITE_ASSET__452e8dae__"